module.exports = __webpack_public_path__ + "img/bim (7).7a1cbfa1.png";